import React from "react";

/**
 * Amber "circuit data was updated" banner.
 *
 * Presentational only: renders nothing unless `count > 0`. The parent owns the
 * staleness fetch and the refresh action.
 *
 * Props:
 *  - count:   number of stale entities (banner hidden when <= 0)
 *  - noun:    singular noun for the entity, e.g. "depot" / "location"
 *  - onRefresh: () => void   refresh handler
 *  - busy:    boolean        disables button + shows busy label
 *  - busyLabel: string       label while busy (default "Refreshing…")
 *  - className: extra classes for the wrapper
 */
export default function CircuitUpdateBanner({
  count,
  noun = "item",
  onRefresh,
  busy = false,
  busyLabel = "Refreshing…",
  className = "",
}) {
  if (!count || count <= 0) return null;

  const plural = count === 1 ? noun : `${noun}s`;
  const verb = count === 1 ? "is" : "are";

  return (
    <div
      className={`mb-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800 ${className}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>
          Power-circuit data has been updated.{" "}
          <span className="font-semibold">
            {count} {plural}
          </span>{" "}
          {verb} still using older circuit values.
        </span>
        <button
          type="button"
          onClick={onRefresh}
          disabled={busy}
          className="rounded border border-amber-400 bg-white px-2 py-1 font-semibold text-amber-700 hover:bg-amber-100 disabled:opacity-50"
        >
          {busy ? busyLabel : "Refresh now"}
        </button>
      </div>
    </div>
  );
}
